import { Flex } from "@chakra-ui/react"
import { useSimulacaoProduto } from "../../contexts/SimulacaoProdutoContext"
import { Trow } from "./Trow"
import { Tside } from "./Tside"
import { formatPrice } from "../../../../../utils/formatPrice"

const dados = [
  {
    quantidade: 1,
    preco: "R$: 20.000,00",
    total: "R$: 20.000,00",
    total_percent: "R$: 20.00",
    custo_total: "R$: 60.00",
    valor_venda_total: "R$: 110,00",
    lucro_liq: "R$: 50,00",
    porcentagem: "48%",
    custo_unit_importador: "R$: 20.00",
    custo_unit_imp: "R$: 20.00",
    setup_maq: "R$: 20.00",
    setup_unit: "R$: 20.00",
    custo_setup: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    outros_custos_unit: "R$: 20.00",
    total_outros: "R$: 20.00",
    boleto: "R$: 20.00",
    frete_compra: "R$: 20.00",
    caixa_util: "R$: 20.00",
    valor_caixa_util: "R$: 20.00",
    quant_caixa: "R$: 20.00",
    caixas_util: "R$: 20.00",
    valor_caixas_tot: "R$: 20.00",
    comissao: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    adc_1: "R$: 20.00",
    adc_2: "R$: 20.00",
    adc_loja: "R$: 20.00",
    add_vendas_demi: "R$: 20.00",
  },
  {
    quantidade: 1,
    preco: "R$: 20.000,00",
    total: "R$: 20.000,00",
    total_percent: "R$: 20.00",
    custo_total: "R$: 60.00",
    valor_venda_total: "R$: 110,00",
    lucro_liq: "R$: 50,00",
    porcentagem: "48%",
    custo_unit_importador: "R$: 20.00",
    custo_unit_imp: "R$: 20.00",
    setup_maq: "R$: 20.00",
    setup_unit: "R$: 20.00",
    custo_setup: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    outros_custos_unit: "R$: 20.00",
    total_outros: "R$: 20.00",
    boleto: "R$: 20.00",
    frete_compra: "R$: 20.00",
    caixa_util: "R$: 20.00",
    valor_caixa_util: "R$: 20.00",
    quant_caixa: "R$: 20.00",
    caixas_util: "R$: 20.00",
    valor_caixas_tot: "R$: 20.00",
    comissao: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    adc_1: "R$: 20.00",
    adc_2: "R$: 20.00",
    adc_loja: "R$: 20.00",
    add_vendas_demi: "R$: 20.00",
  },
  {
    quantidade: 1,
    preco: "R$: 20.000,00",
    total: "R$: 20.000,00",
    total_percent: "R$: 20.00",
    custo_total: "R$: 60.00",
    valor_venda_total: "R$: 110,00",
    lucro_liq: "R$: 50,00",
    porcentagem: "48%",
    custo_unit_importador: "R$: 20.00",
    custo_unit_imp: "R$: 20.00",
    setup_maq: "R$: 20.00",
    setup_unit: "R$: 20.00",
    custo_setup: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    outros_custos_unit: "R$: 20.00",
    total_outros: "R$: 20.00",
    boleto: "R$: 20.00",
    frete_compra: "R$: 20.00",
    caixa_util: "R$: 20.00",
    valor_caixa_util: "R$: 20.00",
    quant_caixa: "R$: 20.00",
    caixas_util: "R$: 20.00",
    valor_caixas_tot: "R$: 20.00",
    comissao: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    adc_1: "R$: 20.00",
    adc_2: "R$: 20.00",
    adc_loja: "R$: 20.00",
    add_vendas_demi: "R$: 20.00",
  },
  {
    quantidade: 1,
    preco: "R$: 20.000,00",
    total: "R$: 20.000,00",
    total_percent: "R$: 20.00",
    custo_total: "R$: 60.00",
    valor_venda_total: "R$: 110,00",
    lucro_liq: "R$: 50,00",
    porcentagem: "48%",
    custo_unit_importador: "R$: 20.00",
    custo_unit_imp: "R$: 20.00",
    setup_maq: "R$: 20.00",
    setup_unit: "R$: 20.00",
    custo_setup: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    outros_custos_unit: "R$: 20.00",
    total_outros: "R$: 20.00",
    boleto: "R$: 20.00",
    frete_compra: "R$: 20.00",
    caixa_util: "R$: 20.00",
    valor_caixa_util: "R$: 20.00",
    quant_caixa: "R$: 20.00",
    caixas_util: "R$: 20.00",
    valor_caixas_tot: "R$: 20.00",
    comissao: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    adc_1: "R$: 20.00",
    adc_2: "R$: 20.00",
    adc_loja: "R$: 20.00",
    add_vendas_demi: "R$: 20.00",
  },
  {
    quantidade: 1,
    preco: "R$: 20.000,00",
    total: "R$: 20.000,00",
    total_percent: "R$: 20.00",
    custo_total: "R$: 60.00",
    valor_venda_total: "R$: 110,00",
    lucro_liq: "R$: 50,00",
    porcentagem: "48%",
    custo_unit_importador: "R$: 20.00",
    custo_unit_imp: "R$: 20.00",
    setup_maq: "R$: 20.00",
    setup_unit: "R$: 20.00",
    custo_setup: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    outros_custos_unit: "R$: 20.00",
    total_outros: "R$: 20.00",
    boleto: "R$: 20.00",
    frete_compra: "R$: 20.00",
    caixa_util: "R$: 20.00",
    valor_caixa_util: "R$: 20.00",
    quant_caixa: "R$: 20.00",
    caixas_util: "R$: 20.00",
    valor_caixas_tot: "R$: 20.00",
    comissao: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    adc_1: "R$: 20.00",
    adc_2: "R$: 20.00",
    adc_loja: "R$: 20.00",
    add_vendas_demi: "R$: 20.00",
  },
  {
    quantidade: 1,
    preco: "R$: 20.000,00",
    total: "R$: 20.000,00",
    total_percent: "R$: 20.00",
    custo_total: "R$: 60.00",
    valor_venda_total: "R$: 110,00",
    lucro_liq: "R$: 50,00",
    porcentagem: "48%",
    custo_unit_importador: "R$: 20.00",
    custo_unit_imp: "R$: 20.00",
    setup_maq: "R$: 20.00",
    setup_unit: "R$: 20.00",
    custo_setup: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    outros_custos_unit: "R$: 20.00",
    total_outros: "R$: 20.00",
    boleto: "R$: 20.00",
    frete_compra: "R$: 20.00",
    caixa_util: "R$: 20.00",
    valor_caixa_util: "R$: 20.00",
    quant_caixa: "R$: 20.00",
    caixas_util: "R$: 20.00",
    valor_caixas_tot: "R$: 20.00",
    comissao: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    adc_1: "R$: 20.00",
    adc_2: "R$: 20.00",
    adc_loja: "R$: 20.00",
    add_vendas_demi: "R$: 20.00",
  },
  {
    quantidade: 1,
    preco: "R$: 20.000,00",
    total: "R$: 20.000,00",
    total_percent: "R$: 20.00",
    custo_total: "R$: 60.00",
    valor_venda_total: "R$: 110,00",
    lucro_liq: "R$: 50,00",
    porcentagem: "48%",
    custo_unit_importador: "R$: 20.00",
    custo_unit_imp: "R$: 20.00",
    setup_maq: "R$: 20.00",
    setup_unit: "R$: 20.00",
    custo_setup: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    outros_custos_unit: "R$: 20.00",
    total_outros: "R$: 20.00",
    boleto: "R$: 20.00",
    frete_compra: "R$: 20.00",
    caixa_util: "R$: 20.00",
    valor_caixa_util: "R$: 20.00",
    quant_caixa: "R$: 20.00",
    caixas_util: "R$: 20.00",
    valor_caixas_tot: "R$: 20.00",
    comissao: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    adc_1: "R$: 20.00",
    adc_2: "R$: 20.00",
    adc_loja: "R$: 20.00",
    add_vendas_demi: "R$: 20.00",
  },
  {
    quantidade: 1,
    preco: "R$: 20.000,00",
    total: "R$: 20.000,00",
    total_percent: "R$: 20.00",
    custo_total: "R$: 60.00",
    valor_venda_total: "R$: 110,00",
    lucro_liq: "R$: 50,00",
    porcentagem: "48%",
    custo_unit_importador: "R$: 20.00",
    custo_unit_imp: "R$: 20.00",
    setup_maq: "R$: 20.00",
    setup_unit: "R$: 20.00",
    custo_setup: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    outros_custos_unit: "R$: 20.00",
    total_outros: "R$: 20.00",
    boleto: "R$: 20.00",
    frete_compra: "R$: 20.00",
    caixa_util: "R$: 20.00",
    valor_caixa_util: "R$: 20.00",
    quant_caixa: "R$: 20.00",
    caixas_util: "R$: 20.00",
    valor_caixas_tot: "R$: 20.00",
    comissao: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    adc_1: "R$: 20.00",
    adc_2: "R$: 20.00",
    adc_loja: "R$: 20.00",
    add_vendas_demi: "R$: 20.00",
  },
  {
    quantidade: 1,
    preco: "R$: 20.000,00",
    total: "R$: 20.000,00",
    total_percent: "R$: 20.00",
    custo_total: "R$: 60.00",
    valor_venda_total: "R$: 110,00",
    lucro_liq: "R$: 50,00",
    porcentagem: "48%",
    custo_unit_importador: "R$: 20.00",
    custo_unit_imp: "R$: 20.00",
    setup_maq: "R$: 20.00",
    setup_unit: "R$: 20.00",
    custo_setup: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    outros_custos_unit: "R$: 20.00",
    total_outros: "R$: 20.00",
    boleto: "R$: 20.00",
    frete_compra: "R$: 20.00",
    caixa_util: "R$: 20.00",
    valor_caixa_util: "R$: 20.00",
    quant_caixa: "R$: 20.00",
    caixas_util: "R$: 20.00",
    valor_caixas_tot: "R$: 20.00",
    comissao: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    adc_1: "R$: 20.00",
    adc_2: "R$: 20.00",
    adc_loja: "R$: 20.00",
    add_vendas_demi: "R$: 20.00",
  },
  {
    quantidade: 1,
    preco: "R$: 20.000,00",
    total: "R$: 20.000,00",
    total_percent: "R$: 20.00",
    custo_total: "R$: 60.00",
    valor_venda_total: "R$: 110,00",
    lucro_liq: "R$: 50,00",
    porcentagem: "48%",
    custo_unit_importador: "R$: 20.00",
    custo_unit_imp: "R$: 20.00",
    setup_maq: "R$: 20.00",
    setup_unit: "R$: 20.00",
    custo_setup: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    outros_custos_unit: "R$: 20.00",
    total_outros: "R$: 20.00",
    boleto: "R$: 20.00",
    frete_compra: "R$: 20.00",
    caixa_util: "R$: 20.00",
    valor_caixa_util: "R$: 20.00",
    quant_caixa: "R$: 20.00",
    caixas_util: "R$: 20.00",
    valor_caixas_tot: "R$: 20.00",
    comissao: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    adc_1: "R$: 20.00",
    adc_2: "R$: 20.00",
    adc_loja: "R$: 20.00",
    add_vendas_demi: "R$: 20.00",
  },
  {
    quantidade: 1,
    preco: "R$: 20.000,00",
    total: "R$: 20.000,00",
    total_percent: "R$: 20.00",
    custo_total: "R$: 60.00",
    valor_venda_total: "R$: 110,00",
    lucro_liq: "R$: 50,00",
    porcentagem: "48%",
    custo_unit_importador: "R$: 20.00",
    custo_unit_imp: "R$: 20.00",
    setup_maq: "R$: 20.00",
    setup_unit: "R$: 20.00",
    custo_setup: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    outros_custos_unit: "R$: 20.00",
    total_outros: "R$: 20.00",
    boleto: "R$: 20.00",
    frete_compra: "R$: 20.00",
    caixa_util: "R$: 20.00",
    valor_caixa_util: "R$: 20.00",
    quant_caixa: "R$: 20.00",
    caixas_util: "R$: 20.00",
    valor_caixas_tot: "R$: 20.00",
    comissao: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    adc_1: "R$: 20.00",
    adc_2: "R$: 20.00",
    adc_loja: "R$: 20.00",
    add_vendas_demi: "R$: 20.00",
  },
  {
    quantidade: 1,
    preco: "R$: 20.000,00",
    total: "R$: 20.000,00",
    total_percent: "R$: 20.00",
    custo_total: "R$: 60.00",
    valor_venda_total: "R$: 110,00",
    lucro_liq: "R$: 50,00",
    porcentagem: "48%",
    custo_unit_importador: "R$: 20.00",
    custo_unit_imp: "R$: 20.00",
    setup_maq: "R$: 20.00",
    setup_unit: "R$: 20.00",
    custo_setup: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    outros_custos_unit: "R$: 20.00",
    total_outros: "R$: 20.00",
    boleto: "R$: 20.00",
    frete_compra: "R$: 20.00",
    caixa_util: "R$: 20.00",
    valor_caixa_util: "R$: 20.00",
    quant_caixa: "R$: 20.00",
    caixas_util: "R$: 20.00",
    valor_caixas_tot: "R$: 20.00",
    comissao: "R$: 20.00",
    custo_total_imp: "R$: 20.00",
    adc_1: "R$: 20.00",
    adc_2: "R$: 20.00",
    adc_loja: "R$: 20.00",
    add_vendas_demi: "R$: 20.00",
  },
]

export function Table() {
  const { data } = useSimulacaoProduto()

  const verifyIndexAndSetQuantity = (index) => {
    const options = {
      0: 1,
      1: 30,
      2: 50,
      3: 100,
      4: 200,
      5: 300,
      6: 400,
      7: 500,
      8: 1000,
      9: 5000,
      10: 10000,
      11: 30000,
    }

    return options[index]
  }

  return (
    <Flex gap={1} mt={2}>
      <Flex flexDirection="column">
        <Tside label="Quantidade" dashed />
        <Tside label="PREÇO | VENDA" border />
        <Tside label="VALOR VENDA TOTAL" isDark />
        <Tside label="CUSTO TOTAL" border isDark />
        <Tside label="LUCRO LIQUIDO" dashed />
        <Tside label="PORCENTAGEM" border />
        <Tside label="CUSTO UNIT IMPRESSÃO" border isDark />
        <Tside label="CUSTO UNIT IMP" dashed />
        <Tside label="SETUP MAQ" dashed />
        <Tside label="SETUP UNIT" dashed />
        <Tside label="CUSTO SETUP" dashed />
        <Tside label="CUSTO TOTAL IMP" border />
        <Tside label="OUTROS CUSTOS UNIT" dashed isDark />
        <Tside label="TOTAL OUTROS" isDark border />
        <Tside label="BOLETO" dashed />
        <Tside label="FRETE COMPRA" border />
        <Tside label="VALOR CAIXA UTIL" isDark dashed />
        <Tside label="QUANT CAIXA" dashed isDark />
        <Tside label="CAIXAS UTIL" isDark dashed />
        <Tside label="VALOR CAIXAS TOT" border isDark />
        <Tside label="COMISSAO" dashed />
        <Tside label="CUSTO TOTAL IMP" dashed />
        <Tside label="ADC 1" dashed />
        <Tside label="ADC 2" dashed />
        <Tside label="ADC LOJA" />
        <Tside label="ADD VENDAS DEMI" />
        <Tside label="TOTAL" isDark dashed />
      </Flex>
      <Flex gap=".1rem">
        {data.map((item, index) => (
          <Flex flexDirection="column" key={index}>
            <Trow isQuantity value={verifyIndexAndSetQuantity(index)} />
            <Trow isPrice value={formatPrice(item.Valor_Venda)} />
            <Trow value={formatPrice(item.Valor_Custo_Total)} />
            <Trow value={formatPrice(item.Custo_Produto)} />
            <Trow isPrice value={formatPrice(item.Valor_Lucro_Liquido)} />
            <Trow isPrice value={parseFloat(item.Margem_Lucro).toFixed(2) + " %"} />
            <Trow value={formatPrice(item.Custo_Impressao)} />
            <Trow value={formatPrice(item.Custo_Impressao)} />
            <Trow value={""} />
            <Trow value={"0"} />
            <Trow value={"0"} />
            <Trow value={formatPrice(item.Custo_Impressao)} />
            <Trow value={formatPrice(item.Outros_Custos)} />
            <Trow value={formatPrice(item.Outros_Custos)} />
            <Trow value={formatPrice(item.Custo_Fixo_Boleto)} />
            <Trow value={formatPrice(item.Custo_Fixo_Boleto)} />
            <Trow value={formatPrice(item.Custo_Total_Unit)} />
            <Trow value={item.Quantidade_Caixa_Util} />
            <Trow value={item.Quantidade_Caixa_Util} />
            <Trow value={formatPrice(item.Custo_Total_Caixa)} />
            <Trow value={formatPrice(item.Custo_Fixo_Vendedor)} />
            <Trow value={"nao tem"} />
            <Trow value={formatPrice(item.Custo_Fixo_Adicional_Loja1)} />
            <Trow value={formatPrice(item.Custo_Fixo_Adicional2_Rodrigo)} />
            <Trow value={"adc_loja"} />
            <Trow value={formatPrice(item.Perc_Custo_Fixo_Adcional_Seguranca3)} />
            <Trow value={"total"} />
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}
